// extracted by mini-css-extract-plugin
export var createdDate = "_ma-1";
export var divider = "_ma-2";
export var headerDivider = "_ma-3";
export var messagesCard = "_ma-0";
export var messagesContainer = "_ma-6";
export var messagesContainerWrapper = "_ma-4";
export var showLeftPanelButton = "_ma-8";
export var topButtons = "_ma-7";
export var withPadding = "_ma-5";